import { Entypo, EvilIcons, MaterialIcons } from '@expo/vector-icons'
import React, { FunctionComponent } from 'react'
import {
  Text,
  StyleSheet,
  View,
  TouchableOpacity,
  Platform
} from 'react-native'
import { TextInput } from 'react-native-gesture-handler'
import MyText from './MyText'

const MyTextInput = (props) => {
  const inputRef = React.useRef();

  const [emailError, setEmailError] = React.useState(false);
  const [phoneError, setPhoneError] = React.useState(false);
  const [imoError, setIMOError] = React.useState(false);
  const [passwordError, setPasswordError] = React.useState(false);
  const [verifyPasswordError, setVerifyPasswordError] = React.useState(false);
  const [websiteError, setWebsiteError] = React.useState(false);
  const [vatError, setVatError] = React.useState(false);
  const [visibility, setVisibility] = React.useState(!!props.secureTextEntry);

  const [isFocused, setIsFocused] = React.useState(false);

  React.useEffect(() => {
    let isValid = true;
    const val = props.value;
    if(props.validation == 'email'){
      let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/;
      if (reg.test(val) === false && val != '') {
        setEmailError(true);
        isValid = false;
      }
      else {
        setEmailError(false);
      }
    }
    else if(props.validation == 'phone'){
      setPhoneError(true);
      let reg = /^[\+]?[0-9]{10,15}$/;
      if (reg.test(val) === false && val != '') {
        setPhoneError(true);
        isValid = false;
      }
      else {
        setPhoneError(false);
      }
    }
    else if(props.validation == 'imo'){
      setIMOError(true);
      let reg = /^[0-9]{7}$/; //is 7 digits
      if (reg.test(val) === false && val != '') {
        setIMOError(true);
        isValid = false;
      }
      else {
        setIMOError(false);
      }
    }
    else if(props.validation == 'password'){
      setPasswordError(true);
      //https://stackoverflow.com/questions/19605150/regex-for-password-must-contain-at-least-eight-characters-at-least-one-number-a
      let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/; //Minimum eight characters, at least one uppercase letter, one lowercase letter and one number
      if (reg.test(val) === false && val != '') {
        setPasswordError(true);
        isValid = false;
      }
      else{
        setPasswordError(false);
      }
    }
    else if(props.validation == 'verifyPassword'){
      setVerifyPasswordError(true);
      if(props.value != props.password){
        setVerifyPasswordError(true);
        isValid = false;
      }
      else{
        setVerifyPasswordError(false);
      }
    }
    else if(props.validation == 'website'){
      setWebsiteError(true);
      let reg = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.([-a-zA-Z0-9()@:%_\+.~#?&/=]{2,})/;
      if (reg.test(val) === false && val != '') {
        setWebsiteError(true);
        isValid = false;
      }
      else {
        setWebsiteError(false);
      }
    }
    else if(props.validation == 'vat'){
      setVatError(true);
      let test = (val.length >=5 && val.length <= 15);
      if (!test && val != '') {
        setVatError(true);
        isValid = false;
      }
      else {
        setVatError(false);
      }
    }
    if(props.onChangeValidation){
      props.onChangeValidation(isValid);
    }
  },[props.value])
  
  const ToggleVisibility = () => {
    setVisibility(prev => !prev);
  }
  return (
    <View {...props} style={[{borderRadius: 8}, props.style, styles(props, isFocused).container]}>
      <View style={{borderTopLeftRadius: 7, borderBottomLeftRadius: 7, overflow: 'hidden'}}>
        {
          !props.isInfo && props.icon == 'date' && 
          <EvilIcons pointerEvents="none" style={styles(props, isFocused).icon} name="calendar" size={24} color="white" />
        }
        {
          !props.isInfo && props.icon == 'time' && 
          <Entypo pointerEvents="none" style={styles(props, isFocused).icon} name="back-in-time" size={18} color="white" />
        }
        {
          !props.isInfo && props.icon == 'search' && 
          <Entypo pointerEvents="none" style={styles(props, isFocused).icon} name="magnifying-glass" size={18} color="white" />
        }
        {
          props.secureTextEntry && 
          <TouchableOpacity onPress={ToggleVisibility} style={styles(props, isFocused).iconRightContainer} hitSlop={{top: 20, bottom: 20, left: 20, right: 20}}>
            <MaterialIcons pointerEvents="none" style={styles(props, isFocused).iconRight} name={!visibility?"visibility":"visibility-off"} size={18} color="black" />
          </TouchableOpacity>
        }
      </View>
      <TextInput {...props} 
        ref={inputRef}
        onPressOut={() => props.onPress?props.onPress():false}
        onChangeText={props.onChangeText}
        onEndEditing={props.onEndEditing??null}
        editable={props.isInfo?false:props.editable}
        secureTextEntry={visibility}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        placeholder={props.fancyPlaceholder?'':props.placeholder}
        style={
          [
              {
                paddingLeft: (props.icon && !props.isInfo)?5:null,
                fontFamily: 'Comfortaa-Regular',
                color: '#474747',
                fontSize: 10,
                borderWidth: props.isInfo?0:1,
                padding: props.isInfo?0:7,
                height: 33,
                borderColor: props.hasError?'red':'#bdbdbd',
                borderRadius: 8,
                overflow: 'hidden',
                backgroundColor: (props.editable==false&&props.icon!="date"&&props.icon!="time"&&!props.isInfo)?'#e6e6e6':'white',
                flex: 1,
                borderBottomLeftRadius: (props.icon)?0:null,
                borderTopLeftRadius: (props.icon)?0:null,
                paddingTop: (Platform.OS==='ios'&&!props.isInfo)?9:null,
                outline: 0
              },
              props.style
          ]
        }
      />
      {
        props.fancyPlaceholder &&
        <MyText onPress={() => inputRef.current.focus()} style={styles(props, isFocused).placeholder}>
          {props.placeholder}
        </MyText>
      }
      <MyText style={{display: emailError?'flex':'none', position: 'absolute', color: 'red', fontSize: 7, top: '100%', marginTop: -2}}>
        Please enter a valid email address
      </MyText>
      <MyText style={{display: phoneError?'flex':'none', position: 'absolute', color: 'red', fontSize: 7, top: '100%', marginTop: -2}}>
        Please enter a valid phone number
      </MyText>
      <MyText style={{display: imoError?'flex':'none', position: 'absolute', color: 'red', fontSize: 7, top: '100%', marginTop: -2}}>
        Please enter a valid IMO number
      </MyText>
      <MyText style={{display: verifyPasswordError?'flex':'none', position: 'absolute', color: 'red', fontSize: 7, top: '100%', marginTop: -2}}>
        Passwords do not match
      </MyText>
      <MyText style={{display: websiteError?'flex':'none', position: 'absolute', color: 'red', fontSize: 7, top: '100%', marginTop: -2}}>
        Please enter a valid website
      </MyText>
      <MyText style={{display: vatError?'flex':'none', position: 'absolute', color: 'red', fontSize: 7, top: '100%', marginTop: -2}}>
        Please enter a valid VAT
      </MyText>
    </View>
  )
}
const styles = (props, isFocused) => StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    // justifyContent: 'center',
    // alignItems: 'center',
  },
  icon: {
    // position: 'absolute',
    // left: 0,
    // top: 0,
    backgroundColor: '#b9bab7',
    height: 33,
    lineHeight: 33,
    //Needed for Android, for iOS the parent View is needed
    // borderTopLeftRadius: 7,
    // borderBottomLeftRadius: 7,
    // borderRadius: 7,
    // paddingHorizontal: 2,
    width: 28,
    textAlign: 'center',
    zIndex: 1,
    pointerEvents: 'none',
    // overflow: 'hidden'
  },
  iconRightContainer: {
    position: 'absolute',
    right: 5,
    zIndex: 1
  },
  iconRight: {
    height: 33,
    lineHeight: 33,
    zIndex: 1,
  },
  placeholder: {
    position: 'absolute',
    left: 0,
    top: Platform.OS==='android'?((isFocused||props.value)?-9:1):((isFocused||props.value)?-6:4), //for the border maybe(?)
    paddingLeft: (props.icon && !props.isInfo)?5:null,
    padding: props.isInfo?0:7,
    color: '#474747',
    fontSize: (isFocused||props.value)?8:10,
    opacity: 0.5,
    pointerEvents: 'none'
  }
})
export default MyTextInput